/**
 * تعطیلات رسمی تقویم ملی ایران
 * منبع: time.ir — استخراج از timestamp.ir
 * تولید خودکار — node scripts/generateIranHolidays.mjs
 * جمعه‌های بدون مناسبت رسمی در UI جداگانه علامت‌گذاری می‌شوند.
 */

export const IRAN_NATIONAL_HOLIDAYS = {
  1400: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 9,
      t: "نیمه شعبان"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 2,
      d: 13,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 2,
      d: 23,
      t: "عید فطر"
    },
    {
      m: 2,
      d: 24,
      t: "تعطیل عید فطر"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 3,
      d: 16,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 4,
      d: 26,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 4,
      d: 29,
      t: "عید قربان"
    },
    {
      m: 5,
      d: 6,
      t: "عید غدیر خم"
    },
    {
      m: 5,
      d: 27,
      t: "تاسوعای حسینی"
    },
    {
      m: 5,
      d: 28,
      t: "عاشورای حسینی"
    },
    {
      m: 7,
      d: 6,
      t: "اربعین حسینی"
    },
    {
      m: 7,
      d: 14,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 7,
      d: 23,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 8,
      d: 2,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 10,
      d: 17,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 11,
      d: 26,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 12,
      d: 8,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 12,
      d: 10,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 12,
      d: 28,
      t: "نیمه شعبان"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1401: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 2,
      d: 3,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 2,
      d: 13,
      t: "عید فطر"
    },
    {
      m: 2,
      d: 14,
      t: "تعطیل عید فطر"
    },
    {
      m: 3,
      d: 6,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 4,
      d: 16,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 4,
      d: 19,
      t: "عید قربان"
    },
    {
      m: 4,
      d: 27,
      t: "عید غدیر خم"
    },
    {
      m: 5,
      d: 16,
      t: "تاسوعای حسینی"
    },
    {
      m: 5,
      d: 17,
      t: "عاشورای حسینی"
    },
    {
      m: 6,
      d: 26,
      t: "اربعین حسینی"
    },
    {
      m: 7,
      d: 3,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 7,
      d: 12,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 7,
      d: 21,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 10,
      d: 6,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 11,
      d: 15,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 11,
      d: 27,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 11,
      d: 29,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 12,
      d: 17,
      t: "نیمه شعبان"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1402: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 1,
      d: 23,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 2,
      d: 2,
      t: "عید فطر"
    },
    {
      m: 2,
      d: 3,
      t: "تعطیل عید فطر"
    },
    {
      m: 2,
      d: 26,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 4,
      d: 5,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 4,
      d: 8,
      t: "عید قربان"
    },
    {
      m: 4,
      d: 16,
      t: "عید غدیر خم"
    },
    {
      m: 5,
      d: 5,
      t: "تاسوعای حسینی"
    },
    {
      m: 5,
      d: 6,
      t: "عاشورای حسینی"
    },
    {
      m: 6,
      d: 15,
      t: "اربعین حسینی"
    },
    {
      m: 6,
      d: 23,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 7,
      d: 1,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 7,
      d: 10,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 9,
      d: 25,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 11,
      d: 4,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 11,
      d: 16,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 11,
      d: 18,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 12,
      d: 6,
      t: "نیمه شعبان"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1403: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی / شهادت امام علی (ع)"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 1,
      d: 22,
      t: "عید فطر"
    },
    {
      m: 1,
      d: 23,
      t: "تعطیل عید فطر"
    },
    {
      m: 2,
      d: 15,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 3,
      d: 25,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 3,
      d: 28,
      t: "عید قربان"
    },
    {
      m: 4,
      d: 5,
      t: "عید غدیر خم"
    },
    {
      m: 4,
      d: 26,
      t: "تاسوعای حسینی"
    },
    {
      m: 4,
      d: 27,
      t: "عاشورای حسینی"
    },
    {
      m: 6,
      d: 5,
      t: "اربعین حسینی"
    },
    {
      m: 6,
      d: 13,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 6,
      d: 22,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 6,
      d: 31,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 9,
      d: 15,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 10,
      d: 24,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 11,
      d: 6,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 11,
      d: 8,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 11,
      d: 26,
      t: "نیمه شعبان"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1404: [
    {
      m: 1,
      d: 1,
      t: "نوروز / شهادت امام علی (ع)"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 11,
      t: "عید فطر"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی / تعطیل عید فطر"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 2,
      d: 4,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره) / شهادت امام محمد باقر (ع)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 3,
      d: 17,
      t: "عید قربان"
    },
    {
      m: 3,
      d: 25,
      t: "عید غدیر خم"
    },
    {
      m: 4,
      d: 14,
      t: "تاسوعای حسینی"
    },
    {
      m: 4,
      d: 15,
      t: "عاشورای حسینی"
    },
    {
      m: 5,
      d: 24,
      t: "اربعین حسینی"
    },
    {
      m: 6,
      d: 1,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 6,
      d: 10,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 6,
      d: 19,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 9,
      d: 3,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 10,
      d: 12,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 10,
      d: 24,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 10,
      d: 26,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 11,
      d: 14,
      t: "نیمه شعبان"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 12,
      d: 19,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت / عید فطر"
    }
  ],
  1405: [
    {
      m: 1,
      d: 1,
      t: "عید فطر / نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 1,
      d: 24,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 3,
      d: 3,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 3,
      d: 6,
      t: "عید قربان"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره) / عید غدیر خم"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 4,
      d: 3,
      t: "تاسوعای حسینی"
    },
    {
      m: 4,
      d: 4,
      t: "عاشورای حسینی"
    },
    {
      m: 4,
      d: 13,
      t: "تعطیلی استان تهران"
    },
    {
      m: 4,
      d: 14,
      t: "تعطیلی استان تهران"
    },
    {
      m: 4,
      d: 15,
      t: "تعطیلی سراسری کشور"
    },
    {
      m: 5,
      d: 13,
      t: "اربعین حسینی"
    },
    {
      m: 5,
      d: 21,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 5,
      d: 22,
      t: "رحلت رضا (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 5,
      d: 30,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 6,
      d: 8,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 8,
      d: 22,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 10,
      d: 2,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 10,
      d: 16,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 11,
      d: 4,
      t: "نیمه شعبان"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 12,
      d: 9,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 12,
      d: 19,
      t: "عید فطر"
    },
    {
      m: 12,
      d: 20,
      t: "تعطیل عید فطر"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1406: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 1,
      d: 14,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 2,
      d: 24,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 2,
      d: 28,
      t: "عید قربان"
    },
    {
      m: 3,
      d: 5,
      t: "عید غدیر خم"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره)"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 3,
      d: 25,
      t: "تاسوعای حسینی"
    },
    {
      m: 3,
      d: 26,
      t: "عاشورای حسینی"
    },
    {
      m: 5,
      d: 4,
      t: "اربعین حسینی"
    },
    {
      m: 5,
      d: 12,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 5,
      d: 13,
      t: "رحلت رضا (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 5,
      d: 21,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 5,
      d: 30,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 8,
      d: 13,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 9,
      d: 23,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 10,
      d: 3,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 10,
      d: 7,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 10,
      d: 24,
      t: "نیمه شعبان"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 11,
      d: 29,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 12,
      d: 9,
      t: "عید فطر"
    },
    {
      m: 12,
      d: 10,
      t: "تعطیل عید فطر"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ],
  1407: [
    {
      m: 1,
      d: 1,
      t: "نوروز"
    },
    {
      m: 1,
      d: 2,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 3,
      t: "عید نوروز / شهادت امام جعفر صادق (ع)"
    },
    {
      m: 1,
      d: 4,
      t: "عید نوروز"
    },
    {
      m: 1,
      d: 12,
      t: "روز جمهوری اسلامی"
    },
    {
      m: 1,
      d: 13,
      t: "روز طبیعت (سیزده‌به‌در)"
    },
    {
      m: 2,
      d: 13,
      t: "شهادت امام محمد باقر (ع)"
    },
    {
      m: 2,
      d: 16,
      t: "عید قربان"
    },
    {
      m: 2,
      d: 24,
      t: "عید غدیر خم"
    },
    {
      m: 3,
      d: 13,
      t: "تاسوعای حسینی"
    },
    {
      m: 3,
      d: 14,
      t: "رحلت امام خمینی (ره) / عاشورای حسینی"
    },
    {
      m: 3,
      d: 15,
      t: "قیام ۱۵ خرداد"
    },
    {
      m: 4,
      d: 23,
      t: "اربعین حسینی"
    },
    {
      m: 4,
      d: 31,
      t: "رحلت پیامبر (ص) و شهادت امام حسن (ع)"
    },
    {
      m: 5,
      d: 9,
      t: "شهادت امام حسن عسکری (ع)"
    },
    {
      m: 5,
      d: 18,
      t: "میلاد پیامبر (ص) و امام صادق (ع)"
    },
    {
      m: 8,
      d: 1,
      t: "شهادت حضرت فاطمه (س)"
    },
    {
      m: 9,
      d: 10,
      t: "ولادت امام علی (ع)"
    },
    {
      m: 9,
      d: 22,
      t: "شهادت امام موسی کاظم (ع)"
    },
    {
      m: 9,
      d: 24,
      t: "مبعث پیامبر (ص)"
    },
    {
      m: 10,
      d: 12,
      t: "نیمه شعبان"
    },
    {
      m: 11,
      d: 17,
      t: "شهادت امام علی (ع)"
    },
    {
      m: 11,
      d: 22,
      t: "پیروزی انقلاب اسلامی"
    },
    {
      m: 11,
      d: 27,
      t: "عید فطر"
    },
    {
      m: 11,
      d: 28,
      t: "تعطیل عید فطر"
    },
    {
      m: 12,
      d: 21,
      t: "شهادت امام جعفر صادق (ع)"
    },
    {
      m: 12,
      d: 29,
      t: "ملی شدن صنعت نفت"
    }
  ]
};
